import script from "./OtaManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./OtaManagement.vue?vue&type=script&setup=true&lang=js"

import "./OtaManagement.vue?vue&type=style&index=0&id=7e673f97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e673f97"]])

export default __exports__